var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsString, Matches } from 'class-validator';
import { Paragraf18MitteilungVariant } from '../enums/paragraf-18-mitteilung-variant.enum.js';
import { CALENDAR_DATE } from './calendar-date.js';
/**
 * A generated § 18 Mitteilung, as metadata (TM-9636 / #1632).
 *
 * ⚠ **Without the bytes.** The sheet is loaded over the document route
 * (`GET /v1/pvs/documents/:documentId`), like the Begleitzettel: a second route
 * onto the same bytes would be a second place where it is decided who may see
 * them.
 */
export class Paragraf18MitteilungDto {
    id;
    /** The occasion: beginning or end of the Beauftragung. */
    variant;
    /** The stored PDF. To be loaded over the document route. */
    documentId;
    /** ISO 8601. When the sheet came into being. */
    generatedAt;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], Paragraf18MitteilungDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], Paragraf18MitteilungDto.prototype, "variant", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], Paragraf18MitteilungDto.prototype, "documentId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], Paragraf18MitteilungDto.prototype, "generatedAt", void 0);
/**
 * A Kasse and what the practice told it (TM-9636 / #1632).
 *
 * ⚠ **The Kostenträger, not the Kasse from the card.** The Mitteilung goes to
 * the party that holds and pays the invoice; `CONTEXT.md` names it in
 * *Echtzulassung* verbatim as *"A Kostenträger's statement"* and calls it *"per
 * Kasse"* in the same sentence. The Karten-IK stands on the Begleitzettel,
 * because Anlage 4 explicitly asks for it there; here nobody asks for it.
 */
export class Paragraf18KasseDto {
    /** The Kostenträger's IK. */
    kostentraegerIk;
    /** The name as the run froze it, or `null` when there is none. */
    kostentraegerName;
    /** When the practice notified this Kasse, `YYYY-MM-DD`, or `null`. */
    notifiedOn;
    /**
     * Whether this Kasse received a Lieferung without having been notified.
     *
     * ⚠ **Never a Versand precondition.** A run starts with open Kassen too
     * (#1582, #1591); this column is information for the practice and not a
     * barrier.
     */
    missing;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], Paragraf18KasseDto.prototype, "kostentraegerIk", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], Paragraf18KasseDto.prototype, "kostentraegerName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], Paragraf18KasseDto.prototype, "notifiedOn", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], Paragraf18KasseDto.prototype, "missing", void 0);
/**
 * Antwort von
 * `GET /v1/office-locations/:officeLocationId/abrechnungsbeauftragung/kassen`
 * (TM-9636 / #1632).
 */
export class Paragraf18KassenResponseDto {
    /**
     * The Kassen that received a Lieferung of this Beauftragung, plus the ones
     * already notified — sorted by IK.
     *
     * Empty as long as there is no Beauftragung or nothing has gone out yet.
     */
    kassen;
}
__decorate([
    Expose(),
    Type(() => Paragraf18KasseDto),
    __metadata("design:type", Array)
], Paragraf18KassenResponseDto.prototype, "kassen", void 0);
/**
 * Body von
 * `PUT /v1/office-locations/:officeLocationId/abrechnungsbeauftragung/kassen/:kostentraegerIk`
 * (TM-9636 / #1632).
 */
export class MarkKasseNotifiedDto {
    /**
     * The day the practice notified the Kasse, `YYYY-MM-DD`.
     *
     * ⚠ **A date from the input and not "today".** The letter goes out on paper,
     * and a practice records afterwards what it sent the day before yesterday. A
     * timestamp from the click would claim a different day.
     */
    notifiedOn;
}
__decorate([
    IsString(),
    Matches(CALENDAR_DATE, { message: 'notifiedOn must be formatted YYYY-MM-DD.' }),
    __metadata("design:type", String)
], MarkKasseNotifiedDto.prototype, "notifiedOn", void 0);
//# sourceMappingURL=paragraf-18-mitteilung.dto.js.map